import {useQuery} from "react-query";
import {Client} from "../../autogenerate/api.generated.clients";

export const useSoftwareVersionFleetReport = function () {
    return useQuery(`software-version-fleet-report`, () => new Client().report_GetFleetSoftwareVersionReport())
};